import React from "react";
import { StyleSheet } from "react-native";
import { useTranslation } from "react-i18next";
import { Button, Dialog, Portal, Text, TextInput } from "react-native-paper";
import { KeyboardAvoidingView } from "react-native-keyboard-controller";

interface RenameFileDialogProps {
  visible: boolean;
  fileName: string;
  error: string;
  onChangeName: (name: string) => void;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function RenameFileDialog({
  visible,
  fileName,
  error,
  onChangeName,
  onConfirm,
  onCancel,
}: RenameFileDialogProps) {
  const { t } = useTranslation();

  return (
    <Portal>
      <KeyboardAvoidingView behavior="padding">
        <Dialog visible={visible} onDismiss={onCancel}>
          <Dialog.Title>{t("Edit")}</Dialog.Title>
          <Dialog.Content>
            <TextInput
              label={t("Name")}
              value={fileName}
              onChangeText={onChangeName}
              error={!!error}
              autoFocus
            />
            {error ? <Text style={styles.errorText}>{error}</Text> : null}
          </Dialog.Content>
          <Dialog.Actions>
            <Button onPress={onCancel}>{t("Cancel")}</Button>
            <Button onPress={onConfirm}>{t("Save")}</Button>
          </Dialog.Actions>
        </Dialog>
      </KeyboardAvoidingView>
    </Portal>
  );
}

const styles = StyleSheet.create({
  errorText: {
    color: "#B00020",
    fontSize: 12,
    marginTop: 4,
  },
});
